module.exports = __webpack_public_path__ + "img/incidence-travel.557f3675.svg";